import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { observable } from "mobx";
import classNames from "classnames";
import PropTypes from "prop-types";
import DomainNameUtils from "~/utils/DomainNameUtils";
import ForgotPasswordForm from "../components/ForgotPasswordForm";
import ForgotPasswordStore from "../stores/ForgotPasswordStore";
import ForgotPasswordDisambiguation from "../components/ForgotPasswordDisambiguation";
import FlashMessageStore from "~/stores/FlashMessageStore";
import CustomBrandingStyle from "~/components/CustomBrandingStyle";

@observer
class ForgotPasswordPage extends Component {
  /**
   * @type {ForgotPasswordStore}
   */
  @observable forgotPasswordStore;

  constructor(props) {
    super(props);

    this.forgotPasswordStore = new ForgotPasswordStore();
  }

  componentDidMount() {
    const { t } = this.props;

    document.title = t("login:forgotPasswordDot");
  }

  render() {
    const { flashMessageStore } = this.props;

    return (
      <>
        <CustomBrandingStyle />
        <main
          className={classNames(
            "forgot-password",
            { "custom-domain": DomainNameUtils.isCustomDomain() },
            { "my-urbanimmersive": DomainNameUtils.isMyUrbanimmersive() },
          )}
        >
          <div className="forgot-password-modal">
            <div className="forgot-password-content">
              {!this.forgotPasswordStore.isDisambiguation && (
                <ForgotPasswordForm
                  forgotPasswordStore={this.forgotPasswordStore}
                  flashMessageStore={flashMessageStore}
                />
              )}
              {this.forgotPasswordStore.isDisambiguation && (
                <ForgotPasswordDisambiguation forgotPasswordStore={this.forgotPasswordStore} />
              )}
            </div>
          </div>
        </main>
      </>
    );
  }
}

ForgotPasswordPage.propTypes = {
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ForgotPasswordPage);
